import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { Box, Button as MuiButton, Typography } from '@mui/material';
import { spacing, SpacingProps } from '@mui/system';

export interface ErrorViewProps {
  title: string;
  heading: string;
  message: string;
  buttonText: string;
  buttonUrl?: string | null;
  icon: React.ComponentType<{ className?: string }>;
}

interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}

const Button = styled(MuiButton)<ButtonProps>(spacing);

const Wrapper = styled.div`
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
`;

function ErrorView({ title, heading, message, buttonText, buttonUrl, icon }: ErrorViewProps) {
  const ErrorIcon = styled(icon)`
    width: 145px;
    height: 145px;
    color: #607d8b;
  `;

  return (
    <Wrapper>
      <Helmet title={title} />
      <Typography variant="h1" align="center" mb={7} gutterBottom>
        {heading}
      </Typography>
      <Box my={5}>
        <ErrorIcon />
      </Box>
      <Typography mt={5} variant="h4" align="center" gutterBottom>
        {message}
      </Typography>
      <Button component={Link} to={buttonUrl || '/'} variant="contained" color="secondary" mt={6} sx={{ fontSize: 14 }}>
        {buttonText}
      </Button>
    </Wrapper>
  );
}

export default ErrorView;
